import { FundClassArgs } from './../../shared/models/fundClassArgs.model';
import { Component, OnInit } from '@angular/core';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { DatePipe } from '@angular/common';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { MeasureStruct } from 'app/shared/models/measureStruct.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { Answer } from 'app/shared/models/Answer.model';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';
import { TRCUSPSBusAddr } from 'app/shared/models/trcUSPSBusAddr.model';
import { FormBuilder } from '@angular/forms';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { PermitQues } from 'app/shared/models/permitQues.model';
import { WebLogon } from 'app/shared/models/webLogon.model';
import { ActivatedRoute, Router } from '@angular/router';
import { TRCForms } from 'app/shared/models/tRCForms.model';
import { LoaderService } from 'app/service/loader/loader.service';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'jhi-eappreg-confirm',
  templateUrl: './eappreg-confirm.component.html',
  styleUrls: ['./eappreg-confirm.component.scss']
})
export class EappregConfirmComponent implements OnInit {

  eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
  trcAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "");
  trcStreetTypes = JSON.parse(sessionStorage.getItem("TRCStreetTypes") ?? "")
  trcUnitTypes = JSON.parse(sessionStorage.getItem("TRCUnitTypes") ?? "")
  trcbusTypes = JSON.parse(sessionStorage.getItem("TRCBusTypes") ?? "")
  trcNextSteps: TRCNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "");
  //Define vars used by dsp_questions_answers
  DispOnlyInd = "Y"
  DispSeqType = "A"  // 'N' for numbers, 'A' for alphabets 
  busType = "";
  bAUnitType = ""
  mAUnitType = ""
  // taxpayer has this number of days from the business start date to register in order to be considered timely
  grace_days = 45;
  inCityFlag = true;
  AddrStatus = "NYV";
  defaultPmtType = "CHE";
  defaultPmtAmt = 0;
  seqNbr = 1;
  RevenueType = "";
  revTypeInitTaxPeriod = true;
  busInitTaxPeriod = "";
  postMarkDate: any;
  busStartDate: any;
  ErrMsg = "";
  StrNbr: any;
  docType = "NAS";
  systemDate: any;
  revTypeStruct = new MeasureStruct();

  resData1: any
  lgr1: any = [];
  lgr2: any = [];
  lgr1_added = false
  lgr2_added = false
  webFilingId: any
  masterAcctNbr: any
  chkDigit: any
  ReturnCode: any
  gisLaLong: any
  toDate: any
  qDesc: any
  eappreg_confirm = this.formBuilder.group({})
  trcQGroups = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "")
  qQuestions: Questionnaire[] = []
  level1Questionnaire = []
  qQuestions1: Questionnaire[] = []
  level2Questionnaire = []
  level3Questionnaire = []
  DispSeqInd = ""
  DispSeqIndN = "N"
  DispSeqIndY = "Y"
  fromDate: any
  revenueType: any
  qTaxCalInfo: any
  measure = 0;
  taxDue = 0
  qTaxInfo: any;
  clientBrowser: any;
  trcFundClasses: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "[]")
  permitQuestions = JSON.parse(sessionStorage.getItem("permitQuestions") ?? "[]")
  TRCQForms = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]")
  loaderService:any

  constructor(private formBuilder: FormBuilder,
    private datepipe: DatePipe,
    private businessRegAppService: BussinessRegAppService,
    private router: Router,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loader: LoaderService) {
    this.loaderService = this.loader;
    history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
          history.go(1);
      };
    const currentpage = sessionStorage.getItem("TRCCurrentPage");
    if (currentpage === "eappreg_app") {
      sessionStorage.setItem("TRCCurrentPage", "eappreg_confirm")
    } else if (currentpage === "eappreg_confirm") {
      // refreshed
    } else {
      // Didn't come from right program so proceed to error page.
      this.router.navigate(['error-page'])
      return;
    }
  }

  ngOnInit(): void {
	const TRCCurrGrpMetaName = sessionStorage.getItem("TRCCurrGrpMetaName");
	if(TRCCurrGrpMetaName === "FASTTRACKGRP" ){
	this.trcAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "") 
	 this.businessRegAppService.getQuestionHierarchyWithId(sessionStorage.getItem("TRCFastTrackGrpId") ?? "").subscribe((res : any)=>{
             this.qQuestions1 = res ;
})   
  
	this.qQuestions = this.route.snapshot.data["busVerificationQuestions"]

    const fundClassList = this.trcFundClasses.map((k: TRCFundClasses) => k.revenue_type)
      const trcForms = new TRCForms()
      trcForms.trcFundClasses = fundClassList      
    
    }
   else{
    this.trcAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "")
    this.qQuestions = this.route.snapshot.data["busVerificationQuestions"]
    this.qQuestions1 = this.route.snapshot.data["level1Questions"]

    const fundClassList = this.trcFundClasses.map((k: TRCFundClasses) => k.revenue_type)
      const trcForms = new TRCForms()
      trcForms.trcFundClasses = fundClassList
      trcForms.trcPLCForm = JSON.parse(sessionStorage.getItem("TRCPLCForm") ?? "[]")
      trcForms.trcFREForm = JSON.parse(sessionStorage.getItem("TRCFREForm") ?? "[]")
      trcForms.trcTBCForm = JSON.parse(sessionStorage.getItem("TRCTBCForm") ?? "[]")
      this.businessRegAppService.getPermitQues(trcForms).subscribe((permitRes: any) => {
        this.permitQuestions = permitRes;
      })
    this.businessRegAppService.getCurrLvlQuesToDisplay(
      {
        "trcList": this.TRCQForms,
        "bussinessGrpId": sessionStorage.getItem("TRCBusGrpId") ?? "",
        "currLevel": "2"
      }
    ).subscribe((res:any)=>{
      this.level2Questionnaire = res
    })
    this.businessRegAppService.getCurrLvlQuesToDisplay(
      {
        "trcList": this.TRCQForms,
        "bussinessGrpId": sessionStorage.getItem("TRCBusGrpId") ?? "",
        "currLevel": "3"
      }
    ).subscribe((res:any)=>{
      this.level3Questionnaire = res
    })}
    this.getDescription();

  }

  //GET DESCRIPTIONS FOR SOME OF THE DROP-DOWN MENU SELECTIONS
  getDescription(): void {
    //Get the Business Address Street Type Desc 
    if (this.trcAppForm.ba1_Str_Type.length > 0) {
      if (sessionStorage.getItem("TRCqBAStreetType")) {
        sessionStorage.removeItem("TRCqBAStreetType")
      }
      sessionStorage.setItem("TRCqBAStreetType", this.trcStreetTypes.filter((el: any) => el.strStreet_Cd === this.trcAppForm.ba1_Str_Type)[0].strDescription)
    } else {
      sessionStorage.setItem("TRCqBAStreetType", "")
    }

    //Get the Mailing Address Street Type Desc
    if (this.trcAppForm.ma1_Str_Type.length > 0) {
      if (sessionStorage.getItem("TRCqMAStreetType")) {
        sessionStorage.removeItem("TRCqMAStreetType")
      }
      sessionStorage.setItem("TRCqMAStreetType", this.trcStreetTypes.filter((el: any) => el.strStreet_Cd === this.trcAppForm.ma1_Str_Type)[0].strDescription)
    } else {
      sessionStorage.setItem("TRCqMAStreetType", "")
    }
    //Get the Business Address Unit Type Desc
    if (this.trcAppForm.ba2_Unit_Type.length > 0) {
      if (sessionStorage.getItem("TRCUnitTypeDesc")) {
        sessionStorage.removeItem("TRCUnitTypeDesc")
      }
      this.bAUnitType = this.trcUnitTypes.filter((el: any) => el.strUnit_Cd === this.trcAppForm.ba2_Unit_Type)[0].strDescription
      sessionStorage.setItem("TRCUnitTypeDesc", this.bAUnitType)
    } else {
      sessionStorage.setItem("TRCUnitTypeDesc", "")
      this.bAUnitType = ""
    }

    //Get the Mailing Address Unit Type Desc
    if (this.trcAppForm.mA2_Unit_Type.length > 0) {
      if (sessionStorage.getItem("TRCMailUnitTypeDesc")) {
        sessionStorage.removeItem("TRCMailUnitTypeDesc")
      }
      this.mAUnitType = this.trcUnitTypes.filter((el: any) => el.strUnit_Cd === this.trcAppForm.mA2_Unit_Type)[0].strDescription
      sessionStorage.setItem("TRCMailUnitTypeDesc", this.mAUnitType)
    } else {
      sessionStorage.setItem("TRCMailUnitTypeDesc", "")
      this.mAUnitType = ""
    }

    // Get the Business Type Desc
    this.busType = this.trcbusTypes.filter((el: any) => el.miscType === this.trcAppForm.busact_Bus_Type)[0].description

  }

  eappreg_confirm_action(): void {

    this.revTypeStruct.description = "";
    this.revTypeStruct.measure = 0;
    this.postMarkDate = this.datepipe.transform(new Date(this.trcAppForm.postMarkDt), 'MM/dd/yyyy')
    this.trcAppForm.busact_Start_Dt = new Date(this.trcAppForm.busact_Start_Dt).toISOString()
    if (this.trcAppForm.ba1_Str_Nbr?.length === 0) {
      this.StrNbr = 0
    } else {
      this.StrNbr = this.trcAppForm.ba1_Str_Nbr
    }

    this.docType = "NAS"

    this.businessRegAppService.getSystemDate().subscribe((res: string) => {
      this.systemDate = new Date(res);
    }, () => {
      // empty method
    }, () => {
      this.lgr1 = ["L041", "L042"]
      this.lgr2 = ["L043", "L044", "L045"]

      for (let i = 0; i < this.lgr1.length; i++) {
        const fcindex = this.trcFundClasses.findIndex((el: TRCFundClasses) => this.lgr1[i] === el.revenue_type)
        if (fcindex >= 0) {
          this.trcFundClasses.splice(fcindex,1)
          if (!this.lgr1_added) {
            const revTypeStruct = new TRCFundClasses();
            revTypeStruct.revenue_type = "LGR1"
            this.trcFundClasses.push(revTypeStruct)
            this.lgr1_added = true
          }
        }
      }

for(let j =0 ;j <this.trcFundClasses.length;j++){
		if(this.trcFundClasses[j].revenue_type==="LGR2"){
			this.lgr2_added = true;
		}
	}
	
	
      for (let i = 0; i < this.lgr2.length; i++) {
        const fcindex = this.trcFundClasses.findIndex((el: TRCFundClasses) => this.lgr2[i] === el.revenue_type)
        if (fcindex >= 0) {
          this.trcFundClasses.splice(fcindex,1)
		if(!this.lgr2_added){
            const revTypeStruct = new TRCFundClasses();
            revTypeStruct.revenue_type = "LGR2"
            this.trcFundClasses.push(revTypeStruct)
            this.lgr2_added = true
        }
      }
}
      // Get next web filing id
      this.businessRegAppService.getNextGUN("WEB_FILING_HDR", "WEB_FILING_ID").subscribe((nextGunRes: any) => {
        this.webFilingId = nextGunRes;
        //Get next master acct number
        this.businessRegAppService.getNextRegNbr("REGISTRATION", "REGISTRATION_NUMBER").subscribe((nextRegNbr: any) => {
          this.masterAcctNbr = nextRegNbr;
          //Get the check digit for the location acct number
          this.businessRegAppService.getCheckDigit(this.masterAcctNbr, "0001").subscribe((chkDigitRes: any) => {
            this.chkDigit = chkDigitRes;

            this.trcAppForm.registration_Number = this.masterAcctNbr
            this.trcAppForm.location_Acct_Number = `${String(this.masterAcctNbr)}0001${String(this.chkDigit)}`
            this.trcAppForm.web_Filing_Id = this.webFilingId

            //Confirm #: "R" + Web Filing ID + MMDDYYYY 
            this.trcAppForm.web_Confirmation_Nbr = "R" + this.trcAppForm.web_Filing_Id + this.postMarkDate.split("/").join("")
            this.trcAppForm.created_By = this.eAppRegConstant.CreatedBy
            this.trcAppForm.timeStampCurrent = this.systemDate

            //Some Questionnaire data needed in web_eappreg_master table to be included in lockbox file
            const trcQForms: Answer[] = JSON.parse(sessionStorage.getItem("TRCQForms") ?? "");
            const trcObj1 = trcQForms.find(obj => obj.metaName === "SSN")
            this.trcAppForm.ssn = trcObj1?.answerTxt.split("-").join("")
            const trcObj2 = trcQForms.find(obj => obj.metaName === "FEIN")
            this.trcAppForm.fein = trcObj2?.answerTxt.split("-").join("")

            sessionStorage.setItem("TRCReceiptType", "Application for Tax Registration Certificate")

            sessionStorage.setItem("TRCTotalTaxDue", "0")

            const fundClassArgs = new FundClassArgs()
            fundClassArgs.web_Filing_Id = this.webFilingId
            fundClassArgs.user = this.eAppRegConstant.CreatedBy
            fundClassArgs.timeStampCurrent = this.systemDate
            //SET OUTSIDE_BOUNDARY_FLAG AND ADDRESS_STATUS

            if (sessionStorage.getItem("TRCUSPSBusAddr")) {
              //We have a good formatted address that conforms to the USPS standard.
              //Code1 call(s) succeeded.  Change status from Not Yet Validated to Not GeoCoded.
              const trcUSPSBusAddr: TRCUSPSBusAddr = JSON.parse(sessionStorage.getItem("TRCUSPSBusAddr") ?? "")
              this.AddrStatus = "FND"
              this.inCityFlag = trcUSPSBusAddr.in_city.toLowerCase() === 'true'?true:false;
            }

            this.inCityFlag === true ? this.trcAppForm.outside_boundary_flag = "N" : this.trcAppForm.outside_boundary_flag = "Y";
            this.trcAppForm.address_status = this.AddrStatus
            // ADD L288 IF L188 + IN-CITY
            /*if (this.trcFundClasses.find((el: TRCFundClasses) => "L188" === el.revenue_type) !== undefined && this.inCityFlag) {
              const revTypeStruct = new TRCFundClasses();
              revTypeStruct.revenue_type = "L288"
              this.trcFundClasses.push(revTypeStruct)
            }
            sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses))*/
            sessionStorage.setItem("TRCAppForm", JSON.stringify(this.trcAppForm))
          
            /* =========================================================================
              POPULATE WEB_EAPPREG_MASTER TABLE
             ==========================================================================*/
            this.businessRegAppService.saveAllData({
              objTRCAppForm: {
                "busDesc": this.trcAppForm.bus_Desc,
                "webfilingId": this.trcAppForm.web_Filing_Id,
                "webConfirmationNbr": this.trcAppForm.web_Confirmation_Nbr,
                "busIdLegalNm": this.trcAppForm.busid_Legal_Nm,
                "busidIdCheck": this.trcAppForm.busid_idcheck,
                "busidDbaNm": this.trcAppForm.busid_Dba_Nm,
                "busactStartDt": this.trcAppForm.busact_Start_Dt,
                "busactBusType": this.trcAppForm.busact_Bus_Type,
                "busactSellerPermit": this.trcAppForm.busact_Seller_Permit,
                "busactIrsActivityCd1": this.trcAppForm.busact_Irs_Activity_Cd,
                "busactIrsActivityCd2": this.trcAppForm.busact_Irs_Activity_Cd2,
				"busactIrsActivityCd3": this.trcAppForm.busact_Irs_Activity_Cd3,
				"busactIrsActivityCd4": this.trcAppForm.busact_Irs_Activity_Cd4,
                "busconNameFirst": this.trcAppForm.buson_Name_First,
                "busconNameLast": this.trcAppForm.buson_Name_Last,
                "busconTitle": this.trcAppForm.buson_Title,
                "busPhoneNbr": this.trcAppForm.buson_Phone_Nbr,
                "busconPhoneExt": this.trcAppForm.buson_Phone_Ext,
                "busconEmail": this.trcAppForm.buson_Email,
                "busconWebAddress": this.trcAppForm.buson_Web_Address,
                "filerNameFirst": this.trcAppForm.filer_Name_First,
                "filerNameLast": this.trcAppForm.filer_Name_Last,
                "filerTitle": this.trcAppForm.filer_Title,
                "filerPhoneNbr": this.trcAppForm.filer_Phone_Nbr,
                "filerPhoneExt": this.trcAppForm.filer_Phone_Ext,
                "filerEmail": this.trcAppForm.filer_Email,
                "ba0Commercial": this.trcAppForm.ba0_Commerical,
                "ba1StrNbr": this.trcAppForm.ba1_Str_Nbr,
                "ba1StrNbrFrac": this.trcAppForm.ba1_Str_Nbr_Frac,
                "ba1StrDirPrefix": this.trcAppForm.ba1_Str_Dir_Prefix,
                "ba1StrNm": this.trcAppForm.ba1_Str_Nm,
                "ba1StrDirSuffix": this.trcAppForm.ba1_Str_Dir_Suffix,
                "ba1StrType": this.trcAppForm.ba1_Str_Type,
                "ba2UnitType": this.trcAppForm.ba2_Unit_Type,
                "ba2UnitNbr": this.trcAppForm.ba2_Unit_Nbr,
                "ba2Careof": this.trcAppForm.ba2_CareOf,
                "ba3City": this.trcAppForm.ba3_City,
                "ba3State": this.trcAppForm.ba3_State,
                "ba3Zipcd": this.trcAppForm.ba3_ZipCd,
                "mailaddrSameAsBusaddr": this.trcAppForm.ma0_Sameas_Ba,
                "ma0Commercial": this.trcAppForm.ma0_Commerical,
                "ma1StrNbr": this.trcAppForm.ma1_Str_Nbr,
                "ma1StrNbrFrac": this.trcAppForm.ma1_Str_Nbr_Frac,
                "ma1StrDirPrefix": this.trcAppForm.ma1_Str_Dir_Prefix,
                "ma1StrNm": this.trcAppForm.ma1_Str_Nm,
                "ma1StrDirSuffix": this.trcAppForm.ma1_Str_Dir_Suffix,
                "ma1StrType": this.trcAppForm.ma1_Str_Type,
                "ma2UnitType": this.trcAppForm.mA2_Unit_Type,
                "ma2UnitNbr": this.trcAppForm.ma2_Unit_Nbr,
                "ma2Careof": this.trcAppForm.ma2_CareOf,
                "ma3City": this.trcAppForm.ma3_City,
                "ma3State": this.trcAppForm.ma3_State,
                "ma3Zipcd": this.trcAppForm.ma3_ZipCd,
                "modifiedBy": this.trcAppForm.modified_By,
                "modifiedDt": (new Date()).toISOString(),
                "createdBy": this.trcAppForm.created_By,
                "createdDt": (new Date()).toISOString(),
                "exemptionId": this.trcAppForm.exemption_Id,
                "registrationNumber": this.trcAppForm.registration_Number,
                "locationAcctNumber": this.trcAppForm.location_Acct_Number,
                "user": this.trcAppForm.user,
                "timeStampCurrent": this.trcAppForm.timeStampCurrent,
                "ssn": this.trcAppForm.ssn,
                "fein": this.trcAppForm.fein,
                "outsideBoundaryFlag": this.trcAppForm.outside_boundary_flag,
                "addressStatus": this.trcAppForm.address_status,
                "postmarkDt": this.trcAppForm.postMarkDt,
                "payReceipt" : this.trcAppForm.payReceipt,
				"referenceNo" : sessionStorage.getItem("ReferenceNo"),
				"reason" : sessionStorage.getItem("Reason"),
				//INC0754669 - Enhancement - PFA EappReg - Adding GGR
				"ggr" : this.trcAppForm.ggr
              },
              trcfundclasses: this.trcFundClasses,
              trcQforms: JSON.parse(sessionStorage.getItem("TRCQForms") ?? "[]"),
              tRCPlcForm: JSON.parse(sessionStorage.getItem("TRCPLCForm") ?? "[]"),
              tRCFreForm: JSON.parse(sessionStorage.getItem("TRCFREForm") ?? "[]"),
              tRCTbcForm: JSON.parse(sessionStorage.getItem("TRCTBCForm") ?? "[]"),
              inCityFlag:this.inCityFlag
            }).subscribe((resData: any) => {
			// INC0726581 Adding a new condition to restrict user not to submit without eappreg_detail records.
			if(resData==='' || resData===null){
				this.resData1=resData;
				const title = "Validation"
					const body = "There was an error encountered in application process. Please try again."
					const modalRef = this.modalService.open(CustomAlertModalComponent)
					modalRef.componentInstance.cModalTitle = title
					modalRef.componentInstance.cModalBody = body
					modalRef.result.then((userResponse) => {
						if (userResponse === "OK") {
							this.router.navigate(['eappreg_criteria'])
						}
					});
			}
			else{
              this.busInitTaxPeriod = resData.busIntTaxPeriod
              sessionStorage.setItem("TRCFundClasses", JSON.stringify(resData.trcFundClasses))
              sessionStorage.setItem("TRCTotalTaxDue",String(resData.tRCTotalTaxDue))
              this.trcNextSteps.addlTaxWarning = resData.trcNextSteps.addlTaxWarning
              this.trcNextSteps.setupFrePermit = resData.trcNextSteps.setupFrePermit
              this.trcNextSteps.setupPlcCryWolfPermit = resData.trcNextSteps.setupPlcCryWolfPermit
              this.trcNextSteps.setupPlcMedallionPermit = resData.trcNextSteps.setupPlcMedallionPermit
              this.trcNextSteps.setupTbcPermit = resData.trcNextSteps.setupTbcPermit
              sessionStorage.setItem("TRCNextSteps", JSON.stringify(this.trcNextSteps));
            }}, () => {
              // empty
            }, () => {
              //LOG TAXPAYER LOGON DATA
			if(this.resData1==='' || this.resData1===null){
					return;
			}
			else{
              const webLogonTxPayer = new WebLogon();
              webLogonTxPayer.taxPeriod = this.busInitTaxPeriod
              webLogonTxPayer.streetNbr = this.StrNbr
              webLogonTxPayer.createdDt = this.systemDate
              webLogonTxPayer.pageVisited = this.router.url.substring(1);
              webLogonTxPayer.accountNbr = this.trcAppForm.registration_Number ;
              webLogonTxPayer.zipCode = this.trcAppForm.ba3_ZipCd ;
              webLogonTxPayer.webFilingId = this.webFilingId ;
              this.businessRegAppService.InsWebLogon(
                {
                  "webLogon": webLogonTxPayer,
                  "tableNm": "WEB_TAXPAYER_LOGON_DATA",
                  "columnNm": "WEB_TAXPAYER_LOGON_DATA_ID"
                }
              ).subscribe((taxpayerLogonDataID: string) => {
                sessionStorage.setItem("TaxPayerLogonDataID", taxpayerLogonDataID);
                //JUMP TO NEXT PAGE
                this.router.navigate(['/eappreg_trc'])
              });
            }})

          })
        })
      })
    });
}

  getGrpQues(questionGroupId: any): any {
    this.businessRegAppService.getGrpQuestions(questionGroupId).subscribe((res: any) => {
      this.qQuestions = res;
      return this.qQuestions;
    })
  }

  getDisplaySeqInd(ind: string): any {
    this.DispSeqInd = ind
    return this.DispSeqInd;
  }

  getPermitQues(): any {
    const qPermitQ: PermitQues = JSON.parse(sessionStorage.getItem("qPermitQues") ?? "")
    return qPermitQ;
  }

back() : void {
	const TRCBackPage = sessionStorage.getItem("TRCBackPage");
	//INC0666070 - resetting the date if user comes back from Confirmation Screen to again load fund class and measures properly 
	this.trcAppForm.busact_Start_Dt="";	
	sessionStorage.setItem("TRCAppForm", JSON.stringify(this.trcAppForm));
	if(TRCBackPage === "FASTTRACK" ){
		this.router.navigate(['/eappreg_fasttrack'])
		}
		else{
		this.router.navigate(['/eappreg_questionnaire'])	
		}    					
}

  print_page(): void {
    window.print();
  }

  get sessionStorage(): any {
    return sessionStorage;
  }
  
  setTRCCurrGrpMetaName(metaName:string):void{
  sessionStorage.setItem("TRCCurrGrpMetaName",metaName)
  }

}
